import countriesData from "./countriesData.json";

const getCountryData = (code: string) => {
	return countriesData.find((country) => country.short_name === code);
};

export default getCountryData;
